import React, { FC, useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useCanvaService } from '../services/canvaService';
import { ReactComponent as CanvaLogo } from '../../../ui/assets/canva_logo.svg';

interface ConnectToCanvaButtonProps {
  disabled: boolean;
}

export const ConnectToCanvaButton: FC<ConnectToCanvaButtonProps> = props => {
  const { disabled } = props;
  const { getCanvaCompanyPortalLink } = useCanvaService();
  const connectToCanva = useCallback(async () => {
    try {
      const response = await getCanvaCompanyPortalLink();
      const w = 520;
      const h = 870;

      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = height / 2 - h / 2 + dualScreenTop;

      window.open(response.data.url, '_blank', `height=${h},width=${w},top=${top},left=${left}`);
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <Button
      onClick={connectToCanva}
      variant="outlined"
      size="small"
      fullWidth
      disabled={disabled}
      sx={{ minWidth: '200px', paddingLeft: 0 }}
    >
      <Box
        sx={{
          width: '25px',
          marginRight: '5px',
          height: '25px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CanvaLogo />
      </Box>

      <Typography variant="button">Connect to Canva</Typography>
    </Button>
  );
};
